import styled from 'styled-components';

interface TextProps {
  size?: string;
  weight?: string;
  color?: string;
  textalign?: 'start' | 'end' | 'center' | 'justify';
}

export const Text = styled.span<TextProps>`
  display: inline-block;
  text-align: ${(props) => props.textalign ?? 'center'};
  word-break: break-word;
  font-size: ${(props) => (props.size ? `var(${props.size})` : 'inherit')};
  font-weight: ${(props) =>
    props.weight ? `var(${props.weight})` : 'inherit'};
  color: ${(props) => (props.color ? `var(${props.color})` : 'inherit')};
`;
